<div class="mt-3">
  @if (highChartOptions) {
    <highcharts-chart
      [Highcharts]="highChart"
      [options]="highChartOptions" style="display: block;"></highcharts-chart>
  }
</div>
